import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { useShowConversation } from "../hooks/useShowConversation";
import ChatMessage from "./common/ChatMessage";
import HelpInputArea from "./common/HelpInputArea";
import SkeletonLoader from "./common/SkeletonLoader";

const ConversationView = ({ conversationId }: { conversationId: string }) => {
  const { data: conversation, isLoading } = useShowConversation(conversationId);
  const message = {
    id: "1",
    type: "bot" as const,
    authorAvatarUrl: "",
    authorName: "Circle Bot",
    content: t("support_widget_v2.chat_bot.templates.conversation_select_type"),
    buttons: [
      {
        label: t("support_widget.chatbot.contact_methods.live_chat"),
        event: "select-contact-method",
        value: "live-chat",
        sublabel: t("support_widget.chatbot.estimated_wait_time", {
          time: "5-10 min",
        }),
        isPreferred: true,
      },
      {
        label: t("support_widget.chatbot.contact_methods.email"),
        event: "select-contact-method",
        value: "email",
        sublabel: t("support_widget.chatbot.estimated_wait_time", {
          time: "24 hrs",
        }),
        isPreferred: false,
      },
    ],
    attachments: [],
    createdAt: "",
    showDisclaimer: false,
  };

  if (isLoading) {
    return (
      <div className="flex h-full w-full flex-1 flex-col px-4">
        <SkeletonLoader rows={4} height="52px" wrapperClassName="!px-0" />
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col">
      <div className="p-4">
        <Typography.BodySm>{conversation?.title}</Typography.BodySm>
        <Typography.BodySm>{conversation?.status}</Typography.BodySm>
        <Typography.BodySm>
          {conversation?.state_transition?.join(" → ")}
        </Typography.BodySm>
      </div>
      <div className="flex-1">
        <ChatMessage {...message} />
      </div>
      <div className="sticky bottom-0 z-10 p-4">
        <HelpInputArea
          onSubmit={() => {}}
          placeholder={t(
            "support_widget_v2.conversation_page.help_input_placeholder",
          )}
        />
      </div>
      <div className="sticky bottom-0 flex justify-center rounded-lg px-4 pb-4">
        <Typography.BodySm color="text-tertiary">
          {t("support_widget_v2.conversation_page.footer_message")}
          <Icon type="info" size={14} />
        </Typography.BodySm>
      </div>
    </div>
  );
};

export default ConversationView;
